import { Toaster } from "@/components/ui/sonner";
import { createContext, type ReactNode, useContext } from "react";
import { toast } from "sonner";

type ToastVariant = "info" | "success" | "error" | "warning";

interface ToastContextType {
  toaster: (message: string, variant?: ToastVariant) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const toaster = (msg: string, variant: ToastVariant = "info") => {
    toast[variant](msg);
  };

  return (
    <ToastContext.Provider value={{ toaster }}>
      <Toaster position="bottom-center" duration={4000} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
